import React, { useEffect } from 'react';
import type { RouteComponentProps } from '@gatsbyjs/reach-router';
import cn from 'classnames';

import RouteEnum from '../RouteEnum';
import { Logger } from '../services/Logger';
import MetaTags from '../views/MetaTags';
import T from '../views/Translate';

import { StaticImage } from './Image';
import Link from './Link';

import styles from './notFound.module.scss';

const NotFound = (_: RouteComponentProps) => {
  useEffect(() => {
    Logger.default.warning(`Page not found`);
  }, []);

  return (
    <main className="main-container container container--top container--bottom">
      <MetaTags title="notFound.title" />
      <div>
        <div className={styles.notFoundSpacing}>
          <h1 className={styles.notFoundTextColor}>
            <T id="notFound.title.404" />
          </h1>
          <h1>
            <T id="notFound.title.description" />
          </h1>
        </div>
        <div className={cn(styles.notFoundSpacing, styles.notFoundDescriptionContainer)}>
          <div className="flex flex-column">
            <div className={styles.notFoundDescription}>
              <T id="notFound.text" multiline />
            </div>
            <div className={cn(styles.notFoundDescription, 'mt-5')}>
              <T id="notFound.links.title" />
            </div>
            <Link
              className={cn(styles.notFoundDescription, styles.notFoundTextColor, 'mt-5')}
              hash="owner-stories"
              to={RouteEnum.STATIC_OFFER}
            >
              <T id="notFound.links.ownerStories" />
            </Link>
            <Link
              className={cn(styles.notFoundDescription, styles.notFoundTextColor, 'mt-5')}
              to={RouteEnum.STATIC_FAQ}
            >
              <T id="notFound.links.exploreFaq" />
            </Link>
            <Link
              className={cn(styles.notFoundDescription, styles.notFoundTextColor, 'mt-5')}
              hash="earnings-calculator"
              to={RouteEnum.STATIC_OFFER}
            >
              <T id="notFound.links.earnings" />
            </Link>
          </div>
          <StaticImage alt="404" name="error-404" />
        </div>
      </div>
    </main>
  );
};

export default NotFound;
